import React, { useEffect } from "react";
import SimpleModal from "components/Modal/SimpleModal";
import { Button, Col, Form, Input, Row, Spin } from "antd";
import IntlMessages from "util/IntlMessages";
import { useSelector, useDispatch } from "react-redux";
import { DataRequestActionAPI } from "../../../../redux/actions/http";

const AddItemModal = () => {
  const dispatch = useDispatch();
  const inventoryProps = useSelector((state) => state.inventory);
  const { inventorySpinner, inventorySuccess, addItemModalVisible } =
    inventoryProps;

  const [form] = Form.useForm();

  const addItem = (values) => {
    dispatch(
      DataRequestActionAPI(
        "POST",
        "addHealthBandInventory",
        "AddInventory",
        values,
        "",
        "InventoryLoading",
        true
      )
    );
  };

  useEffect(() => {
    if (inventorySuccess) {
      toggleAddItemModal();
    }
  }, [inventorySuccess]);

  const toggleAddItemModal = () => {
    dispatch({ type: "Hide_AddItem_Modal" });
    form.resetFields();
  };

  return (
    <>
      <SimpleModal
        visible={addItemModalVisible}
        width={500}
        modalFor="Hide_AddItem_Modal"
        // closeFn={toggleAddItemModal}
        title={<IntlMessages id="inventory.addItem" />}
      >
        <Form form={form} layout="vertical" name="addItem" onFinish={addItem}>
          <Row className="gx-d-flex gx-flex-row">
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-pl-0">
              <Form.Item
                name="imei"
                label={<IntlMessages id="inventory.imei" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.imei_message" />,
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="name"
                label={<IntlMessages id="inventory.name" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.name_message" />,
                  },
                ]}
              >
                <Input type="alphabets" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="model"
                label={<IntlMessages id="inventory.model" />}
                rules={[
                  {
                    required: true,
                    message: <IntlMessages id="inventory.model_message" />,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <Form.Item
                name="notes"
                label={<IntlMessages id="inventory.notes" />}
                rules={[
                  {
                    required: false,
                    // message: <IntlMessages id="inventory.notes_message" />,
                  },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
              <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-end ">
                <Form.Item className="gx-mb-0">
                  <Button
                    type="default"
                    className="gx-pt-0 gx-mb-0 gx-mr-2"
                    htmlType="button"
                    onClick={toggleAddItemModal}
                  >
                    <IntlMessages id="inventory.cancel" />
                  </Button>
                </Form.Item>
                <Form.Item className="gx-mb-0">
                  {inventorySpinner ? (
                    <Spin>
                      <Button
                        type="primary"
                        className="gx-pt-0 gx-mb-0"
                        disbaled
                        htmlType="button"
                      >
                        <IntlMessages id="inventory.save" />
                      </Button>
                    </Spin>
                  ) : (
                    <Button
                      type="primary"
                      className="gx-pt-0 gx-mb-0"
                      htmlType="submit"
                    >
                      <IntlMessages id="inventory.save" />
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Form>
      </SimpleModal>
    </>
  );
};

export default AddItemModal;
